import { Alert } from "@mui/material";
import { Stack } from "@mui/system";
import { Permission, usePermission } from "utils/beyonAuth/usePermission";
import { PropsWithChildren } from "react";


export type ProtectedProps = { permission: Permission, workspaceId: string }
    & { fallback?: boolean }
    & PropsWithChildren;

export function PermissionWrapper({ permission, workspaceId, fallback, children }: ProtectedProps) {

    const allowed = usePermission(permission, workspaceId);

    if (allowed === undefined)
        return <></>

    if (allowed)
        return <>{children}</>

    if (fallback)
        return <Stack spacing={1} margin={2}>
            <Alert severity="error" >
                Not authorized
            </Alert>
        </Stack>

    return null;
}